<template>
  <div class="d-flex flex-column flex-column-fluid">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1
            class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
          >
            منصة أكاديميا Academia
          </h1>
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <li class="breadcrumb-item text-muted">
              <a href="../../demo1/dist/index.html" class="text-muted text-hover-primary"
                >الصفحة الرئيسية</a
              >
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">سلة التسوق</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <!-- Additional actions here if needed -->
        </div>
      </div>
    </div>
    <!-- Content -->
    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div
          v-if="isLoading == true"
          style="
            font-weight: 800;
            border-radius: 10px;
            padding: 50px;
            font-size: large;
            text-align: center;
            background: #73737326;
          "
          class="loader text-success"
        >
          جاري التحميل
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <div v-if="isLoggedIn == false && isLoading == false" class="col-12">
          <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-person-badge"></i></span>
            <h3 class="mb-4">يرجى تسجيل الدخول للإستمرار</h3>
            <span>
              <a href="login" class="btn btn-success">
                تسجيل الدخول <i class="fa fa-sign-in"></i>
              </a>
            </span>
          </div>
        </div>

        <div v-if="isLoggedIn == true" class="row g-5 g-xl-10 mb-5 mb-xl-10 cartContent">
          <div class="col-xl-8 col-lg-8 col-md-12 cart-tb" style="display: none">
            <div class="card">
              <div class="card-body">
                <hr />
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>الدورة</th>
                        <th>عنوان الدورة</th>
                        <th></th>
                        <th>السعر</th>
                      </tr>
                    </thead>
                    <tbody id="cartTableBodyCourse">
                      <!-- Cart items will be dynamically added here -->
                    </tbody>
                  </table>
                  <hr />
                  <b>باقات</b>
                  <table class="table">
                    <tbody id="cartTableBodyBundle">
                      <!-- Cart items will be dynamically added here -->
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 cart-tb" style="display: none">
            <div class="card card-body" dir="rtl" style="text-align: right">
              <h4><i class="fa fa-list"> </i> تفاصيل الفاتورة</h4>
              <hr />
              <div class="cartInvoiceContainer" style="width: 100%; height: 100%">
                <table class="table" id="cartInvoiceTable">
                  <tr>
                    <th>التخفيض:</th>
                    <td id="offerPercentCell">__</td>
                  </tr>
                  <tr>
                    <th>تخفيض الكوبون :</th>
                    <td id="couponDiscountCell">__</td>
                  </tr>
                  <tr>
                    <th>الإجمالي:</th>
                    <td id="totalPriceCell">__</td>
                  </tr>
                </table>
                <div class="m-2">
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#applyCouponModal"
                    class="btn btn-sm btn-warning addCoupon"
                    style="display: none"
                  >
                    إستخدام كوبون <i class="fa fa-gift"></i>
                  </button>
                  <span id="removeCouponContainer"></span>
                </div>
              </div>
              <button
                href="#"
                class="btn btn-primary waves-effect waves-light"
                id="confirmPurchase"
                ref="confirmPurchase"
                @click="confirmPurchase"
              >
                تأكيد الشراء <i class="fas fa-check"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Coupon />
</template>

<script>
import $ from "jquery";
import "twbs-pagination";
import { baseUrl, apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure
import Coupon from "./Coupon.vue";
import {
  showCart,
  confirmPurchase,
  removeCartItem,
  generateCartInvoice,
} from "@/utils/cart";

export default {
  name: "Cart",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      respo: localStorage.getItem("respo"),
      baseUrl: baseUrl,
      isEmptyCart: false,
      isLoggedIn: false,
      isLoading: true,
    };
  },
  components: {
    Coupon,
  },
  mounted() {
    this.getBalance();
  },
  methods: {
    showCart,
    removeCartItem,
    generateCartInvoice,
    confirmPurchase() {
      const button = this.$refs.applyCouponBtn;
      confirmPurchase($(button));
    },
    async getBalance() {
      this.loadingBalance = true; // Start loading
      try {
        const response = await fetch(
          `${apiUrl}/wallets/get-balance?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
              "x-country-code": "+218",
            },
          }
        );
        this.isLoading = false;
        if (!response.redirected || !response.ok) {
          this.showCart();
          var cartInvoiceTable = $("#cartInvoiceTable");
          this.generateCartInvoice(cartInvoiceTable);
          this.isLoggedIn = true;
          console.log(response);
        } else {
          this.isLoggedIn = false;
        }
      } catch (error) {
        console.error("Error fetching balance:", error);
      } finally {
        this.loadingBalance = false; // Stop loading
      }
    },
  },
};
</script>

<style scoped>
/* Add your scoped CSS here */
</style>
